
const ChineseAssociation = () => {
    return(
        <div id="CA" className="pageSection caWrapper">
            Chinese Association
        </div>
    )
}

export default ChineseAssociation;